<template>

    <div id="lt_home">
        
        <div class="big_pic"  v-if="item.hp_autoplay_video == '0'" :style="'background-image:url(' + item.pic_cover_tumb + ')'"></div>
        
        <div class="sticker" v-html="item.sticker_text"></div>

        <div class="actions">
            <a @click="item.is_like ? doUnlike() : doLike()" :key="item.is_like" style="cursor:pointer;">
                <i v-show="!item.is_like" class="far fa-heart"></i>
                <i v-show="item.is_like" class="fas fa-heart" style="color:#d82c2c"></i>
                <span v-text="'אהבתי'"></span>
            </a>

            <a :href="'https://www.youtube.com/watch?v=' + item.youtube_code" v-if="item.youtube_code != ''" target="_blank" class="youtube_link" style="cursor:pointer;">
                <i class="fab fa-youtube"></i>
                <span v-text="'לצפייה ביוטיוב'"></span>
            </a>

            <a @click.prevent="validateDownload">
                <i class="fas fa-arrow-down"></i>
                <span>הורד לינקטון</span>
            </a>

            <a @click="$bus.$emit('open_playlist_panel', item)">
                <i class="fas fa-list"></i>
                <span>הוספה לפלייליסט</span>
            </a>

        </div>


        

        <div v-if="!isAlbum" :style="`${isHeb(item.songs[0].lyrics) ? '' : 'direction: rtl; text-align: right;'}`" class="lyrics" v-html="item.songs[0].lyrics"></div>
        <div v-if="isAlbum" class="album_songs">
            <ul>
                <li v-for="(song, idx) in item.songs" :key="song.id" :class="(song.playing_now ? 'active': '')" @click="play_song(song)">
                    <div class="arrow" :key="song.playing_now">
                        <i v-show="song.playing_now" class="fas fa-chevron-up"></i>
                        <i v-show="!song.playing_now" class="fas fa-chevron-down"></i>
                    </div>

                    <div class="options">
                        <a :href="song.download_url"><i class="fas fa-arrow-down"></i></a>
                    </div>

                    <h5 v-text="idx + 1 + '. ' + song.name"></h5>
                    <div :style="`${isHeb(song.lyrics) ? '' : 'direction: rtl; text-align: right;'}`" class="lyrics" v-html="song.lyrics"></div>
                </li>
            </ul>
        </div>


        <div v-if="is_mobile()" id="footer_logos">

            <div v-for="logo in item.companies" :key="logo.id" ><img :src="logo.logo_path" alt="" /></div>

        </div>

    </div>
</template>

<script>



export default {
  props: ["item"],
  data(){
    return {
    }
  },
  methods: {
        validateDownload(){
           if (!this.checkIsMediaUser()) return;
           window.location.href = this.item.song_downloads.mp3.url;
      },
      doLike(){
        
        var self = this;
        this.api({ action: 'likes/add', data: { item_id: this.item.id }}, function(){ 

            self.item.is_like = true;
        });
      },
      doUnlike(){
        
        var self = this;
        this.api({ action: 'likes/remove', data: { item_id: this.item.id }}, function(){ 
            self.item.is_like = false;
        });
      },
      play_song(song)
      {
          if(song.playing_now) return song.playing_now = false;

          for (let i in this.item.songs)
          {
              let songI = this.item.songs[i];
                songI.playing_now=false;
          }
          song.playing_now=true;
      }
  },
  computed: {
      isAlbum(){
          return (this.item.songs.length > 1);
      }
  },
}
</script>

<style lang="scss" scoped>
#lt_home { 

    h3 { font-size: 30px; margin-bottom: 10px;}
    h4 { font-size: 20px; font-weight: normal; margin-bottom: 10px;}
    .left_side { float: left; }
    .date { display: block; }
    .big_pic { display: block;background-position: center center; background-repeat: no-repeat; background-size: cover; border-radius: 25px;box-shadow: 0 12px 47px -4px rgba(0, 0, 0, 0.52);
        @media (max-width: 600px) {min-width: 300px; width: 100%;aspect-ratio: 1;}
        @media (min-width: 600px) {height: 300px; }

    }


 
    .actions { border-top: 1px solid #fff; border-bottom: 1px solid #fff; display: flex; margin: 25px 0;
        @media (min-width: 600px) { padding: 15px; white-space: nowrap;}
        @media (max-width: 600px) {  padding: 15px 0;gap:5px; }

        .youtube_link{
            span{
                @media (max-width: 600px) {white-space: nowrap;}
                @media (min-width: 600px) {}
            }
        }

        & > a { flex: 1;  text-align: center; color: #fff;
            @media (min-width: 600px) { }
            @media (max-width: 600px) { display: flex; flex-direction: column; align-items: center; }
            
            svg {  vertical-align: middle;
                @media (min-width: 600px) { margin-left: 8px; }
            }
        }
     }

     .lyrics { opacity: 0.7; font-size: 17px;}
     .sticker { padding-top:15px;}

    .album_songs {
        ul { list-style: none; padding: 0px;}
        li { 
            &{ display: block; padding:15px 5px; border-top: 1px solid rgba(255,255,255,0.7); margin:0px; cursor: pointer; position: relative; }
            
            h5 { color: rgba(255,255,255,0.8); font-size: 16px; font-weight: normal; padding: 0px;}
            .lyrics { display: none; font-size: 16px;}
            .arrow { position: absolute; left: 10px; top: 15px; font-size: 13px; }
            .options { position: absolute; left: 50px; top: 15px; font-size: 13px; 
                a { color: #fff; }
            }
            &.active { 
                h5 { font-weight: bold; color: #ff256e; margin-bottom: 15px; }
                .lyrics { display: block;}
            }
        }
    }

    

    #footer_logos { display: flex; gap:15px; margin: 25px 0; flex-wrap: wrap;
      div { padding: 4px; border:1px solid rgba(255,255,255,0.6); background: rgba(0,0,0,0.1); border-radius: 6px;}
      img { height: 30px; width: auto;}

    }
}
</style>